// ProtectedRoute.tsx
import { FC } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isAuthenticated } from "@/auth"; // Import the auth function

const ProtectedRoute: FC = () => {
  const isAuth = isAuthenticated();
  if (!isAuth) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
};

export default ProtectedRoute;
